import React from "react";
import styled from "styled-components";
import { Row, Col } from "antd";
import I18n from "../../../i18n";
import { Metrics, Colors } from "../../../theme/";
import Chart from "../../chart/";
import GraphCard from "../GraphCard";
import { ValueP } from "../../list/DataPercentList";
import { MathUtil, isFunction, isFillAlive, OrgUtil } from "../../../util";
import { getSplitRatio } from "../generics";
import { GRAPH } from "../../../constants/limit";
import { SimpleText, OHeader, IncrementText, IncrementTextType } from "../../text/OText";
import { CounselingSupportGraph } from "../../../constants/supportGraph";
import { HoverableDiv } from "../../layout/Layout";

const FeedbackGraph = ({
	height=GRAPH.HEIGHT, colorType,
	header,
	onHeaderClick,
	style, 
	showLegend = true, 
	showColor = true,
	isVertical = false, onClick,
	short, data, previousData,
})=>{
	return (<GraphCard 
		style={{...style, marginTop:Metrics.button.spaceMargin}} 
		header={I18n.t("visit_feedback")}
		onHeaderClick={onHeaderClick}
		height={height}
		isVertical = {isVertical}
		chartWidthRatio={getSplitRatio(short)}
		legendVertHeightRatio={1}
		graph={
			<Chart.ProgressCompareBar 
				height={height}
				data = {data}
				colorType={colorType}
				onClick={onClick}
			/>
		}
		legend={ showLegend && !short ? 
			<VisitLegend style={{height}} 
				isVertical={isVertical} 
				data={data} 
				previousData={previousData}
				onClick={onClick}
			/> : undefined
		}
	/>
	);};

const VisitLegend = ({style, data, previousData = {}, onClick})=>(
	<div style={{...style, padding:"0px 8px", overflowY:"auto"}}>
		{data[CounselingSupportGraph.PatientFeedback] ? 
			<ThumbDetail style={{marginBottom:Metrics.button.bigSpaceMargin}} 
				title={I18n.t("user")} 
				type={CounselingSupportGraph.PatientFeedback}
				data={data[CounselingSupportGraph.PatientFeedback]}
				compareData={previousData[CounselingSupportGraph.PatientFeedback]}
				onClick={onClick}
			/> : undefined}
		{/* {data[CounselingSupportGraph.ProviderFeedback] ? 
			<ThumbDetail title={I18n.t("provider")} 
				type={CounselingSupportGraph.ProviderFeedback}
				data={data[CounselingSupportGraph.ProviderFeedback]}
				compareData={previousData[CounselingSupportGraph.ProviderFeedback]}
				onClick={onClick}
			/> : undefined} */}
	</div>
);
const VisitRow = ({title, showCompare, compare, compareType, type, value, percent, onClick})=>{
	const numMD = showCompare ? 8 : 12;
	return (<HoverableDiv pointer = {onClick} onClick={onClick}>
		<Row>
			<MainCol style={{style:{color:Colors.greyFontColor}}}>
				{title}
			</MainCol>
			<MainCol>
				<Row>
					{showCompare ? 
						<NumberCol md={numMD}>
							{compareType !== IncrementTextType.EQUALS ? 
								<IncrementText type={compareType} value={`${compare}%`} />
								: undefined}
						</NumberCol>: undefined}
					<NumberCol md={numMD}>{value}</NumberCol>
					<NumberCol md={numMD}>{`${percent}%`}</NumberCol>
				</Row>
			</MainCol>
		</Row>
	</HoverableDiv>
	);
};

const compareTypeByRatio = (ratio)=>{
	if(ratio > 0){
		return IncrementTextType.UP;
	}else if(ratio < 0){
		return IncrementTextType.DOWN;
	}
	return IncrementTextType.EQUALS;
};
const ThumbDetail = ({style, title, type, data, onClick, compareData = {}})=>{
	const showCompare = compareData.good !== undefined;
	const compare = {
		good: MathUtil.increaseRatio(data.good, compareData.good),
		bad: MathUtil.increaseRatio(data.bad, compareData.bad)
	};
	const sum = Math.max(1, data.good+data.bad);
	return <div style={style}>
		<OHeader style={{marginBottom:Metrics.button.mediumSpaceMargin}}>
			{title}
		</OHeader>
		<VisitRow 
			title={`${title} ${I18n.t("thumb_up").toLowerCase()}`}
			type={type}
			value={data.good}
			onClick={onClick ? ()=>{
				onClick({type, value:"good"});
			} : undefined}
			showCompare={showCompare}
			compare={Math.abs((compare.good*100).toFixed(2))}
			compareType={compareTypeByRatio(compare.good)}
			percent={((data.good/sum) * 100).toFixed(2)}
		/>
		<VisitRow 
			title={`${title} ${I18n.t("thumb_down").toLowerCase()}`}
			type={type}
			value={data.bad}
			onClick={onClick ? ()=>{
				onClick({type, value:"bad"});
			} : undefined}
			showCompare={showCompare}
			compare={Math.abs((compare.bad * 100).toFixed(2))}
			compareType={compareTypeByRatio(compare.bad)}
			percent={((data.bad/sum) * 100).toFixed(2)}
		/>
	</div>;
};
const MainCol = styled(Col).attrs({
	md:12, xs: 24,
})``;
const NumberCol = styled(Col).attrs({style:{paddingLeft:6, textAlign:"right"}})``;
export default FeedbackGraph;


// WEBPACK FOOTER //
// ./src/components/report/counseling/VisitFeedback.js